import { useUserHasAccess } from '@backoffice-frontend/restricted'
import {
  AREA_ACCESS_RIGHTS,
  AREA_CRUD_RIGHTS,
  DASHBOARD_READ_RIGHTS,
  LINE_SERVICE_ANY_ACCESS_RIGHTS,
  LINE_SERVICE_CRUD_RIGHTS,
  ROAD_BLOCKAGE_CRUD_RIGHTS,
  ROAD_BLOCKAGE_READ_RIGHTS,
  STOP_BULK_CRUD_RIGHTS,
  STOP_CRUD_RIGHTS,
  STOP_DRIVER_VOTING_RIGHTS,
  TURN_RESTRICTION_CRUD_RIGHTS,
  TURN_RESTRICTION_READ_RIGHTS,
} from '../permissions'

/**
 * Central hook that returns all stop-network permission checks.
 *
 * Prefer this hook when a component needs multiple permission checks.
 * For components that only gate on a single right you can also use
 * the constants from `permissions.ts` directly with `<Restricted>` or
 * `useUserHasAccess`.
 */
export const useStopNetworkPermissions = () => {
  const canAccessArea = useUserHasAccess({
    requiredRights: [...AREA_ACCESS_RIGHTS],
  })
  const canReadDashboard = useUserHasAccess({
    requiredRights: [...DASHBOARD_READ_RIGHTS],
  })
  const canEditStops = useUserHasAccess({
    requiredRights: [...STOP_CRUD_RIGHTS],
  })
  const canBulkImportStops = useUserHasAccess({
    requiredRights: [...STOP_BULK_CRUD_RIGHTS],
  })
  const canSeeDriverVoting = useUserHasAccess({
    requiredRights: [...STOP_DRIVER_VOTING_RIGHTS],
  })
  const canEditAreas = useUserHasAccess({
    requiredRights: [...AREA_CRUD_RIGHTS],
  })
  const canReadRoadBlockages = useUserHasAccess({
    requiredRights: [...ROAD_BLOCKAGE_READ_RIGHTS],
  })
  const canEditRoadBlockages = useUserHasAccess({
    requiredRights: [...ROAD_BLOCKAGE_CRUD_RIGHTS],
  })
  const canReadTurnRestrictions = useUserHasAccess({
    requiredRights: [...TURN_RESTRICTION_READ_RIGHTS],
  })
  const canEditTurnRestrictions = useUserHasAccess({
    requiredRights: [...TURN_RESTRICTION_CRUD_RIGHTS],
  })
  const canEditLineService = useUserHasAccess({
    requiredRights: [...LINE_SERVICE_CRUD_RIGHTS],
  })
  const canAccessLineService = useUserHasAccess({
    allowedRights: [...LINE_SERVICE_ANY_ACCESS_RIGHTS],
  })

  return {
    canAccessArea,
    canReadDashboard,
    canEditStops,
    canBulkImportStops,
    canSeeDriverVoting,
    canEditAreas,
    canReadRoadBlockages,
    canEditRoadBlockages,
    canReadTurnRestrictions,
    canEditTurnRestrictions,
    canEditLineService,
    canAccessLineService,
  }
}
